import { render } from "./AppNav.vue?vue&type=template&id=54531dd2&scoped=true"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=54531dd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54531dd2"]])

export default __exports__